import { useaxios } from "../../../utils/useaxios";
export default (expense_amount, expense_type_id, expense_date, expense_note, user_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    initDispatch({ type: 'loadingTrue' });
    useaxios('expense/create.php', { expense_amount, expense_type_id, expense_note, user_id, expense_date }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}